var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01278 2.09178L8.0129 2.09156C8.39281 1.44029 8.93094 1.09502 9.50156 0.987392C10.0709 0.880008 10.6689 1.00976 11.1704 1.30122C11.672 1.59268 12.0803 2.04768 12.2679 2.59489C12.4558 3.14334 12.4206 3.78088 12.0408 4.43211L8.01278 2.09178ZM8.01278 2.09178L1.19516 13.9161L1.18848 13.9277V13.9411C1.18848 13.9536 1.18189 13.9691 1.16713 13.9986C1.16654 13.9998 1.16594 14.001 1.16532 14.0022C1.15366 14.0254 1.13619 14.0602 1.13526 14.0977L0.656159 18.4096C0.627122 18.6709 0.758661 18.8762 0.948461 18.9784C1.13737 19.0802 1.3843 19.08 1.58712 18.9352L1.58776 18.9347L5.04644 16.3806C5.10439 16.351 5.13608 16.3199 5.15999 16.288C5.16747 16.278 5.17485 16.2669 5.18116 16.2575C5.18388 16.2534 5.18641 16.2496 5.18866 16.2464C5.19697 16.2343 5.20499 16.2237 5.21527 16.2134L5.2165 16.2147L5.22318 16.2031L12.0407 4.43224L8.01278 2.09178ZM10.4882 4.71174L8.55082 3.59006L9.05791 2.728L9.05795 2.72801L9.05884 2.72635C9.23874 2.39225 9.49662 2.21555 9.76875 2.1556C10.0422 2.09537 10.3342 2.15216 10.5812 2.29333C10.8282 2.43448 11.0273 2.65829 11.117 2.92814C11.2063 3.19675 11.1885 3.5148 10.9956 3.84926C10.9956 3.84932 10.9955 3.84938 10.9955 3.84944L10.4882 4.71174ZM3.651 15.9698L1.99417 17.188L2.23782 15.1413L3.651 15.9698ZM9.90551 5.75654L4.52217 15.0982L2.53193 13.9755L7.91451 4.58236L9.90551 5.75654Z",
    fill: "#1E294F",
    stroke: "#1E294F",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3c5ef9b4414cde298f703d3fe2549f8f.svg";
export { ForwardRef as ReactComponent };